/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Square shell — Dispositivos.
 * Hardware de esta compu: impresora térmica, comanda, balanza, lector.
 * Todo lo de acá es por-dispositivo (AsyncStorage local), no por-regla
 * de negocio — por eso vive separado de Reglas del POS.
 */
import React from 'react';
import { Text, View } from 'react-native';
import { useContentLayout } from '../../shared/layout/useContentLayout';
import { BranchSettingsHubShell } from './BranchSettingsHubShell';
import { PaperSheet } from '../../shared/ticket/PaperSheet';
import { TicketModuleHeader } from '../../shared/ticket/TicketModuleHeader';
import { settingsStyles as styles } from './settingsScreen.styles';
import type { BranchSettingsScreenViewModel } from './useBranchSettingsScreen';
import { PrintConfigCard } from './components/PrintConfigCard';
import { ComandaCard } from './components/ComandaCard';
import { ScaleCard } from './components/ScaleCard';
import { BarcodeReaderCard } from './components/BarcodeReaderCard';
import { PickupDisplayCard } from './components/PickupDisplayCard';
import { hubStyles } from './components/settingsHubUi';

export function BranchDevicesScreen() {
  const { layoutWide } = useContentLayout('settings');

  return (
    <BranchSettingsHubShell>
      {(vm: BranchSettingsScreenViewModel) => {
        const branchName = vm.currentBranch?.name ?? '';
        return (
          <View style={hubStyles.stack}>
            <TicketModuleHeader kicker="Ajustes" title="Dispositivos" meta={branchName || undefined} />

            <PaperSheet padded>
              <Text style={styles.captionBlock}>
                Los ajustes de impresión y balanza se guardan en esta app o navegador. La lectura de códigos se aplica a toda la sucursal.
              </Text>
            </PaperSheet>

            <PrintConfigCard vm={vm} layoutWide={layoutWide} />
            <ComandaCard vm={vm} />
            {vm.scaleIntegrationsEnabled ? <ScaleCard vm={vm} layoutWide={layoutWide} /> : null}
            <BarcodeReaderCard vm={vm} />
            <PickupDisplayCard vm={vm} />
          </View>
        );
      }}
    </BranchSettingsHubShell>
  );
}
